import apiPDO from '../../../api/supplier/pdo';

const defaultState = () => ({
	listSchedule: [],
	detailPO: {},
	listPDO: [],
	listStatusPDO: [],
	detailPDO: '',
	pdoPagination: '',
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	productPDO(state){
		if (state.detailPDO) {
			return state.detailPDO.pdo_detail.map((el) => {
				return {
					product_id: el.pdo_detail_product_id,
					quantity: el.pdo_detail_quantity_received
				}
			})
		}
	}
};

const mutations = {
	setPDO(state, data) {
		state.listPDO = data.data
		state.pdoPagination = data.pagination;
	},
	setStatusPDO(state, data) {
		state.listStatusPDO = data
	},
	setDetailPDO(state, data) {
		state.detailPDO = data
	},
	setSchedule(state, data) {
		state.listSchedule = data
	},
	setScheduleByDate(state, data) {
		state.detailPO = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
		state.alertMultiple = []
	},
	resetResponse(state) {
		state.response = {
			code: '',
			message: ''
		}
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataPDO() {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getPDO({ commit }, params) {
		return new Promise((resolve) => {
			apiPDO.getPDO(params).then(({ data: { data } }) => {
				commit('setPDO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setPDO', { data: [], pagination: {} });
			});
		});
	},
	getStatusPDO({ commit }) {
		return new Promise((resolve) => {
			apiPDO.getStatusPDO().then(({ data: { data } }) => {
				commit('setStatusPDO', data.results );
				resolve()
			}).catch(() => {
				commit('setStatusPDO', [] );
			});
		});
	},
	getDetailPDO({ commit, dispatch }, params) {
		apiPDO.getDetailPDO(params).then(({ data: { data } }) => {
			commit('setDetailPDO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailPDO', {});
		});
	},
	getSchedule({ commit, dispatch }, params) {
		return new Promise((resolve) => {
			apiPDO.getSchedule(params).then(({ data: { data } }) => {
				commit('setSchedule', data.results );
				resolve()
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
				commit('setSchedule', { data: [] });
			});
		});
	},
	getScheduleByDate({ commit, dispatch }, params) {
		return new Promise((resolve) => {
			apiPDO.getScheduleByDate(params).then(({ data: { data } }) => {
				commit('setScheduleByDate', data.results );
				resolve()
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
				commit('setScheduleByDate', { data: [] });
			});
		});
	},
	async exportPDO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiPDO.exportPDO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data pengiriman penjualan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createPDO({ commit, dispatch }, params) {
		commit('resetResponse')
		await apiPDO.createPDO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal proses penerimaan barang'
			}, { root: true });
		});
	},
	async deliveryPDO({ commit, dispatch }, params) {
		commit('resetResponse')
		await apiPDO.deliveryPDO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal proses penerimaan barang'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};